import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { SharedRoutingModule } from './shared-routing.module';
import { ActiveAccountComponent } from './components/active-account/active-account.component';
import { BillableAccountComponent } from './components/billable-account/billable-account.component';
import { CloudServiceAgreementComponent } from './components/cloud-service-agreement/cloud-service-agreement.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { ImpersonationBannerComponent } from './components/impersonation-banner/impersonation-banner.component';
import { OneColumnModalComponent } from './components/one-column-modal/one-column-modal.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { CanAccessDirective } from './directive/can-access.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { SortArrPipe } from './pipes/sort-arr.pipe';
import { SortByKeyPipe } from './pipes/sort-by-key.pipe';
import { StrReplacePipe } from './pipes/str-replace.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { DateRangePickerComponent } from '../modules/measure/components/date-range-picker/date-range-picker.component';
/* eslint-disable */
@NgModule({
    imports: [
        SharedRoutingModule,
        ConfirmDialogComponent,
        CanAccessDirective,
        ActiveAccountComponent,
        FeedbackComponent,
        StrReplacePipe,
        TruncatePipe,
        WarningModalComponent,
        SuccessModalComponent,
        FilterPipe,
        PaginatorComponent,
        SpinnerComponent,
        DateRangePickerComponent,
        SortArrPipe,
        OneColumnModalComponent,
        CloudServiceAgreementComponent,
        BillableAccountComponent,
        SortByKeyPipe,
        ImpersonationBannerComponent,
    ],
    exports: [
        CommonModule,
        MatSnackBarModule,
        CanAccessDirective,
        ActiveAccountComponent,
        FeedbackComponent,
        PaginatorComponent,
        WarningModalComponent,
        SuccessModalComponent,
        StrReplacePipe,
        TruncatePipe,
        FilterPipe,
        SpinnerComponent,
        DateRangePickerComponent,
        SortArrPipe,
        CloudServiceAgreementComponent,
        ImpersonationBannerComponent,
        BillableAccountComponent,
        SortByKeyPipe,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: SharedModule,
            providers: [],
        };
    }
}
